module.exports = __webpack_public_path__ + "img/snapshot-logo-circle.b453b1fc.svg";